'use strict';

module.exports = [
    {
        value: 'narus',
        label: 'Complex Care Management'
    },
    {
        value: 'lucent',
        label: 'Large Care Management'
    }
];
